
/**
 * 快乐中中中
 */
export namespace HappyWinKind {

    export enum GeneralValue {
        /** 差值 */
        SpaceValue = 0,
    }

    export const CardData = ['A', 2,3,4,5,6,7,8,9,10,'J','Q',"K"];

    /** 中奖概率信息 */
    class WinProbInfo {
        /** 概率 */
        prob: number = 0;
        /** 金额 */
        sum: number = 0;
    }

    /** 中奖概率 */
    export const WinProb: WinProbInfo[] = [
        {
            prob: 0.21
            , sum: 0
        },
        {
            prob: 0.1
            , sum: 500
        },
        {
            prob: 0.15
            , sum: 6666
        },
        {
            prob: 0.15
            , sum: 8888
        },
        {
            prob: 0.1
            , sum: 88000
        },
        {
            prob: 0.07
            , sum: 660000
        },
        {
            prob: 0.05
            , sum: 1000000
        },
    ];

    /** 牌型数据 */
    export class CardTypeData {
        /** 牌 */
        card: number[] = [];
    }

}

